import { render, staticRenderFns } from "./TradesPreview.vue?vue&type=template&id=40de81e6&"
import script from "./TradesPreview.vue?vue&type=script&lang=js&"
export * from "./TradesPreview.vue?vue&type=script&lang=js&"
import style0 from "./TradesPreview.vue?vue&type=style&index=0&id=40de81e6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports